import { parseToHsl } from 'polished';
/**
 * Applies an adjustment to a color based on its HSV/HSB representation.
 * Conversion from https://en.wikipedia.org/wiki/HSL_and_HSV#Interconversion.
 *
 * @param color - color to adjust
 * @param h - amount of hue to adjust [-360, 360]
 * @param s - amount of saturation to adjust [-1, 1]
 * @param v - amount of value/brightness to adjust [-1, 1]
 */
export const applyHSVAdjustment = (color, h = 0, s = 0, v = 0) => {
  const hsl2hsv = c => {
    const v = c.lightness + c.saturation * Math.min(c.lightness, 1 - c.lightness);
    const s = v === 0 ? 0 : 2 * (1 - c.lightness / v);
    return {
      hue: c.hue,
      saturation: s,
      value: v
    };
  };
  const hsv2hsl = c => {
    const l = c.value - c.value * c.saturation / 2;
    const s = l === 0 || l === 1 ? 0 : (c.value - l) / Math.min(l, 1 - l);
    return {
      hue: c.hue,
      saturation: Math.round(s * 100),
      lightness: Math.round(l * 100)
    };
  };

  // Parse out hsl
  // Convert to hsv (hsb)
  // Add adjusted value
  // Convert back to hsl
  const c = parseToHsl(color);
  const hsv = hsl2hsv(c);
  const hsl = hsv2hsl({
    // Ensure values don't escape proper bounds
    hue: Math.max(0, Math.min(360, hsv.hue + h)),
    saturation: Math.max(0, Math.min(1, hsv.saturation + s)),
    value: Math.max(0, Math.min(1, hsv.value + v))
  });
  return `hsl(${Math.round(hsl.hue)}, ${Math.round(hsl.saturation)}%, ${Math.round(hsl.lightness)}%)`;
};
//# sourceMappingURL=applyHSVAdjustment.js.map